import { combineReducers } from 'redux'
import authorizationApplications from './authorizationApplications'
import authorizationContexts from './authorizationContexts'
import authorizationUsers from './authorizationUsers'
import auditHistory from './auditHistory'

const authorizationManagement = combineReducers({
  authorizationApplications,
  authorizationContexts,
  authorizationUsers,
  auditHistory,
})

export default authorizationManagement
